import { StrictMode } from "react";
import { createRoot }  from "react-dom/client";
import "./index.css";
import App from "./App.jsx";

// Load wallet.js before mounting React — exposes window.WalletAPI
// (loaded via <script> in index.html for correct load order)

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
